export default __webpack_public_path__ + "static/media/GER.67bf05d4.svg";